import * as types from '../ActionTypes/GymTvActionTypes';

export class GymTvActionCreators {
    // get channels
    static getGymTvChannelsRequest = () => ({
        type: types.GET_GYM_TV_CHANNELS_REQUEST,
    });

    static getGymTvChannelsSuccess = payload => ({
        type: types.GET_GYM_TV_CHANNELS_SUCCESS,
        payload,
    });

    static getGymTvChannelsFailed = payload => ({
        type: types.GET_GYM_TV_CHANNELS_FAILED,
        payload,
    });

    // create channel
    static createGymTvChannelRequest = () => ({
        type: types.CREATE_GYM_TV_CHANNEL_REQUEST,
    });

    static createGymTvChannelSuccess = payload => ({
        type: types.CREATE_GYM_TV_CHANNEL_SUCCESS,
        payload,
    });

    static createGymTvChannelFailed = payload => ({
        type: types.CREATE_GYM_TV_CHANNEL_FAILED,
        payload,
    });

    // get channel by id
    static getGymTvChannelByIdRequest = (channelId, callback) => ({
        type: types.GET_GYM_TV_CHANNEL_BY_ID_REQUEST,
        meta: { channelId, callback },
    });

    static getGymTvChannelByIdSuccess = payload => ({
        type: types.GET_GYM_TV_CHANNEL_BY_ID_SUCCESS,
        payload,
    });

    static getGymTvChannelByIdFailed = payload => ({
        type: types.GET_GYM_TV_CHANNEL_BY_ID_FAILED,
        payload,
    });

    // update channel by id
    static updateGymTvChannelRequest = (channelId, channelData) => ({
        type: types.UPDATE_GYM_TV_CHANNEL_REQUEST,
        meta: { channelId, channelData },
    });

    static updateGymTvChannelSuccess = payload => ({
        type: types.UPDATE_GYM_TV_CHANNEL_SUCCESS,
        payload,
    });

    static updateGymTvChannelFailed = payload => ({
        type: types.UPDATE_GYM_TV_CHANNEL_FAILED,
        payload,
    });

    // delete channel
    static deleteGymTvChannelRequest = channelId => ({
        type: types.DELETE_GYM_TV_CHANNEL_REQUEST,
        meta: { channelId },
    });

    static deleteGymTvChannelSuccess = payload => ({
        type: types.DELETE_GYM_TV_CHANNEL_SUCCESS,
        payload,
    });

    static deleteGymTvChannelFailed = payload => ({
        type: types.DELETE_GYM_TV_CHANNEL_FAILED,
        payload,
    });

    // get channel items
    static addGymTvChannelItemRequest = (channelId, itemData, callback) => ({
        type: types.ADD_GYM_TV_CHANNEL_ITEM_REQUEST,
        meta: { channelId, itemData, callback },
    });

    static addGymTvChannelItemSuccess = payload => ({
        type: types.ADD_GYM_TV_CHANNEL_ITEM_SUCCESS,
        payload,
    });

    static addGymTvChannelItemFailed = payload => ({
        type: types.ADD_GYM_TV_CHANNEL_ITEM_FAILED,
        payload,
    });

    // update channel item
    static updateGymTvChannelItemRequest = (channelId, itemId, itemData) => ({
        type: types.UPDATE_GYM_TV_CHANNEL_ITEM_REQUEST,
        meta: { channelId, itemId, itemData },
    });

    static updateGymTvChannelItemSuccess = payload => ({
        type: types.UPDATE_GYM_TV_CHANNEL_ITEM_SUCCESS,
        payload,
    });

    static updateGymTvChannelItemFailed = payload => ({
        type: types.UPDATE_GYM_TV_CHANNEL_ITEM_FAILED,
        payload,
    });

    // delete channel item
    static deleteGymTvChannelItemRequest = (channelId, itemId) => ({
        type: types.DELETE_GYM_TV_CHANNEL_ITEM_REQUEST,
        meta: { channelId, itemId },
    });

    static deleteGymTvChannelItemSuccess = payload => ({
        type: types.DELETE_GYM_TV_CHANNEL_ITEM_SUCCESS,
        payload,
    });

    static deleteGymTvChannelItemFailed = payload => ({
        type: types.DELETE_GYM_TV_CHANNEL_ITEM_FAILED,
        payload,
    });

    // duplicate channel
    static duplicateGymTvChannelRequest = channelId => ({
        type: types.DUPLICATE_GYM_TV_CHANNEL_REQUEST,
        meta: { channelId },
    });

    static duplicateGymTvChannelSuccess = payload => ({
        type: types.DUPLICATE_GYM_TV_CHANNEL_SUCCESS,
        payload,
    });

    static duplicateGymTvChannelFailed = payload => ({
        type: types.DUPLICATE_GYM_TV_CHANNEL_FAILED,
        payload,
    });

    // get gym tv classes by room number
    static getGymTvClassesByRoomNumberRequest = (roomNumber, callback) => ({
        type: types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_REQUEST,
        meta: { roomNumber, callback },
    });

    static getGymTvClassesByRoomNumberSuccess = payload => ({
        type: types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_SUCCESS,
        payload,
    });

    static getGymTvClassesByRoomNumberFailed = payload => ({
        type: types.GET_GYM_TV_CLASSES_BY_ROOM_NUMBER_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/GymTvActionCreators.js